<app-navbar></app-navbar>

<div class="min-h-screen bg-gray-100 flex justify-center items-center py-12 px-4">

<div class="w-full max-w-4xl bg-white rounded-2xl shadow-xl p-10">

<div class="mb-10">
<h2 class="text-3xl font-bold text-gray-800">Create Coupon</h2>
<p class="text-gray-500">Generate discount coupons for customers</p>
</div>

<div class="grid md:grid-cols-2 gap-6">

<div>
<label class="block text-sm font-semibold text-gray-700 mb-2">
Coupon Code
</label>
<input
[(ngModel)]="coupon.code"
placeholder="SUMMER50"
class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500 outline-none">
</div>

<div>
<label class="block text-sm font-semibold text-gray-700 mb-2">
Discount %
</label>
<input
type="number"
[(ngModel)]="coupon.discountPercent"
placeholder="5-20%"
class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500 outline-none">
</div>

<div>
<label class="block text-sm font-semibold text-gray-700 mb-2">
Max Discount
</label>
<input
type="number"
[(ngModel)]="coupon.maxDiscount"
placeholder="20-50%"
class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500 outline-none">
</div>

<div>
<label class="block text-sm font-semibold text-gray-700 mb-2">
Expiry Date
</label>
<input
type="datetime-local"
[(ngModel)]="coupon.expiryDate"
class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500 outline-none">
</div>

<div>
<label class="block text-sm font-semibold text-gray-700 mb-2">
Usage Limit
</label>
<input
type="number"
[(ngModel)]="coupon.usageLimit"
placeholder="0"
class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500 outline-none">
</div>

<div>
<label class="block text-sm font-semibold text-gray-700 mb-2">
Product ID (optional)
</label>
<input
type="number"
[(ngModel)]="coupon.productId"
placeholder="0"
class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500 outline-none">
</div>

</div>

<button
(click)="create()"
class="mt-8 w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 rounded-lg font-semibold shadow-md hover:scale-[1.02] transition">
Create Coupon
</button>

</div>
</div>